import { render, staticRenderFns } from "./LanguageSwitcherList.vue?vue&type=template&id=0df82802&scoped=true"
import script from "./LanguageSwitcherList.vue?vue&type=script&lang=js"
export * from "./LanguageSwitcherList.vue?vue&type=script&lang=js"
import style0 from "./LanguageSwitcherList.vue?vue&type=style&index=0&id=0df82802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df82802",
  null
  
)

export default component.exports